import React, { MutableRefObject, useEffect, useRef } from 'react';
import { useScan } from '../../common/context/ScanProvider';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import FormFactory from '@/components/FormFactory';
import { Field } from 'formik';
import { Button } from '@/components/ui/button';
import QuotesService from '@/common/API/QuotesService';
import Input from '@/components/forms/Input';
import Textarea from '@/components/forms/Textarea';
import RichEditor from '@/components/forms/RichEditor';
import { useData } from '@/common/hooks/useData';
import Select from '@/components/forms/Select';
import { useNavigate } from 'react-router';

const QuotesAddScreen = () => {
  const { text } = useScan();
  const formRef: MutableRefObject<any> = useRef();
  const { tags, books } = useData();
  const navigate = useNavigate();

  useEffect(() => {
    if (formRef) {
      console.log();
      // formRef?.current?.setValues(text);
      // formRef.current.setFieldValues({
      //   text,
      // });
    }
  }, [text, tags, books]);

  // if (!text) return <p>Loading</p>;

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        tabNavigator: {
          hide: true,
        },
        header: {
          title: 'Adjust quote',
          backBtnLabel: 'Crop image',
          backBtnUrl: '/scan',
          titleClassName: 'text-white',
        },
      }}
    >
      <ScrollableContainer className='relative'>
        <FormFactory
          formRef={formRef}
          className='grid grid-rows-12 h-full'
          initialValues={{ text: text, tag_id: '', book_id: '' }}
        >
          <Field name='tag_id' options={tags} placeholder='Select tag' component={Select} />
          <Field name='book_id' options={books} placeholder='Select book' component={Select} />
          <Field
            className='row-span-9 h-full'
            name='text'
            placeholder='Text'
            component={RichEditor}
            defaultContent={text}
          />
          <div className='row-span-1 w-full mb-4'>
            <Button
              onClick={() => {
                console.log(formRef.current.values);
                QuotesService.create(formRef.current.values).then((res) => {
                  if (res?.success) {
                    navigate('/home');
                  }
                });
              }}
              className='w-full'
            >
              Submit
            </Button>
          </div>
        </FormFactory>
      </ScrollableContainer>
    </Screen>
  );
};

export default QuotesAddScreen;
